import { Component, Input } from '@angular/core';
import {
  catchError,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  tap,
  throwError,
} from 'rxjs';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { NGOBusinessTypeEnum } from '../../enum/ngo-business-type.enum';
import { NgoModel } from '../../model/register-new-ngo.model';
import { NgoSocialMediaModel } from '../../model/ngo-social-media.model';
import {
  annualReportModel,
  ngoAwardModel,
} from '../../model/annual-report.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NgoService } from '../../services/ngo/ngo.service';
import { FileService } from '../../services/file/file.service';
import { UtilitiesService } from '../../services/utilities/utilities.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { CommonSharedServiceService } from '../../shared-services/common-shared-service/common-shared-service.service';
import Swal from 'sweetalert2';
import { NgoCampaignService } from '../../services/ngo-campaign/ngo-campaign.service';

@Component({
  selector: 'app-common-ngo-profile',
  templateUrl: './common-ngo-profile.component.html',
  styleUrl: './common-ngo-profile.component.scss',
})
export class CommonNgoProfileComponent {
  @Input() public: boolean = false;

  public totalKeys: number = 0;
  public hasValue: number = 0;
  public progress: number = 0;

  public data: any;

  public editorOpened: boolean[] = Array(15).fill(false);
  public expandedState: boolean[] = Array(4).fill(false);
  public ngoRegCertificate: File = null;

  public showProfileUpdate: boolean = false;
  public showCoverUpdate: boolean = false;
  public showMainData: boolean = false;

  public countries: string[] = [
    'Bangladesh',
    'Canada',
    'France',
    'India',
    'United States',
  ];
  public businessTypes: string[] = Object.keys(NGOBusinessTypeEnum);

  public ngoLogo: any = {}; // For showing the image
  public ngoProfilePic: any = {};

  private ngoLogoFile: File = null; // For saving the file
  private ngoProfilePicFile: File = null;

  public ngoCoverPhoto: any = {};

  private imgToDelete: string[] = [];
  public sdgList: any[] = [];
  public ngoSdg: string[];
  public ngoTags: string[];

  public causeAreaList: any[] = [];
  public categoryList: any[] = [];
  public subCategoryMap: any = {};
  public causeAreas: any[] = [
    {
      category: null,
      subcategories: [],
      availableCategories: [],
      availableSubcategories: [],
    },
  ];
  public parsedCauseArea: { category: string; subcategories: string[] }[] = [];

  public workingAddress: any[] = [
    {
      division: null,
      district: null,
      upazila: null,
      union: null,
      ward: null,

      availableDistricts: [],
      availableUpazilas: [],
      availableUnions: [],
    },
  ];
  public locationsTree: any[] = [];
  public unionMap: { [upazilaId: string]: any[] } = {};

  public awards: any[] = [];

  public columns = [
    { dataField: 'year', caption: 'Year' },
    { dataField: 'award_name', caption: 'Award Name' },
    { dataField: 'participant', caption: 'Participant' },
  ];

  public showAll: boolean = false;
  public showAll2: boolean = false;

  public ngoId: string;
  public ngoBody: NgoModel = new NgoModel();
  public editedNgoBody: NgoModel = new NgoModel();
  public socialMedia: NgoSocialMediaModel = new NgoSocialMediaModel();
  public annualReportModel: annualReportModel = new annualReportModel();
  public ngoAwardModel: ngoAwardModel = new ngoAwardModel();

  public annualReports: any = [];
  public selectedNgo: any = null;

  public coverEdit: boolean = false;
  public ngoProfileEdit: boolean = false;
  public ngoInfoEdit: boolean = false;

  public allAnnualReports: any[] = [];

  public allAwardData: any[] = [];

  public awardData: any[] = [];
  public viewDbId: boolean = false;
  private elastic_id: string = null;
  // public ngo: any = null;
  private ngoParams: any;
  public campaigns: any[] = [];

  public coverPhotoSrc: string = './assets/images/icon/shadow_cover_image.svg';
  constructor(
    private readonly route: Router,
    private readonly ngoService: NgoService,
    private readonly router: ActivatedRoute,
    private readonly fileService: FileService,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService,
    private readonly sharedService: CommonSharedServiceService,
    private readonly ngoCampaignService: NgoCampaignService
  ) {}

  async ngOnInit(): Promise<void> {
    // Decrypting the query params

    const params = await firstValueFrom(this.router.queryParams);
    const encryptedString = params['data'];
    const decryptedParams =
      this.localStorageService.decryptObjectUrl(encryptedString);

    if (!decryptedParams) {
      this.route.navigateByUrl('/');
      return;
    }

    // Checking if it is for public view or not
    this.public = decryptedParams.public ?? false;

    // For public view, we need to fetch the NGO data by Elastic ID .
    // For ngo admin , we need to fetch the NFO data by NGO ID.
    if (this.public) {
      this.elastic_id = decryptedParams?.id;

      this.viewDbId = decryptedParams?.dbId || false;

      this.getByElastic();
    } else {
      this.ngoId = decryptedParams.id;

      this.getNgo();
    }

    this.causeAreaList = await firstValueFrom(
      this.ngoService.getCauseAreaList()
    );

    await this.processCauseAreaData();

    const geoList = await firstValueFrom(this.ngoService.getGeoLocationList());
    this.locationsTree = this.buildLocationsTree(geoList);

    this.ngoService.getCampaignSdg().subscribe((result) => {
      this.sdgList = result;
    });

    // changing the ngo from menu , I need to update the selected ngo's data.
    if (!this.public) {
      this.sharedService.ngoSelectionAction$.subscribe((action) => {
        this.selectedNgo = this.localStorageService.getNgoInLocalStorage();
        this.ngoId = this.selectedNgo.id;
        this.getNgo();
      });
    }
  }

  get coverPhotoUrl(): string {
    return `url('${this.ngoProfilePic?.url ?? this.coverPhotoSrc}')`;
  }

  private getByElastic(): void {
    const $api = this.viewDbId
      ? this.ngoService.getNgoById(this.elastic_id)
      : this.ngoService.getNgoByElasticId(this.elastic_id);
    // this.ngoService
    //   .getNgoByElasticId(this.elastic_id)
    $api.subscribe((response: any) => {
      if (response) {
        this.ngoBody = new NgoModel(response);
        this.data = response;
        this.editedNgoBody = JSON.parse(JSON.stringify(this.ngoBody));

        this.socialMedia = new NgoSocialMediaModel(this.editedNgoBody?.socials);

        if (this.editedNgoBody.tags) {
          this.ngoTags = this.editedNgoBody.tags
            .split(',')
            .map((tag) => tag.trim());
        }

        if (this.editedNgoBody.ngo_sdg) {
          this.ngoSdg = this.editedNgoBody.ngo_sdg
            .split(',')
            .map((tag) => tag.trim());
        }

        if (this.editedNgoBody.cause_area) {
          const parsed = JSON.parse(this.editedNgoBody.cause_area);

          this.parsedCauseArea = Array.isArray(parsed) ? parsed : [];

          this.fetchParsedCauseArea();
        } else {
          this.parsedCauseArea = [];

          this.fetchParsedCauseArea();
        }

        if (this.editedNgoBody.work_area_geo_location) {
          const parsed = JSON.parse(this.editedNgoBody.work_area_geo_location);

          this.workingAddress = Array.isArray(parsed) ? parsed : [];

          this.loadWorkingAddresses(parsed);
        }

        this.ngoLogo = this.editedNgoBody?.logo_url
          ? JSON.parse(this.editedNgoBody?.logo_url)
          : {};

        this.ngoProfilePic = this.editedNgoBody?.ngo_profile_img_url
          ? JSON.parse(this.editedNgoBody?.ngo_profile_img_url)
          : {};

        if (this.ngoBody?.ngo_profile_id) {
          this.ngoId = this.ngoBody?.ngo_profile_id;
          this.getAnnualReports();
          this.getNgoAward();
          this.getAllCampaignByNgo();
        }
      }
    });
  }

  public getAllCampaignByNgo(ngoId: string = this.ngoId): void {
    this.ngoCampaignService
      .getNgoDonationCampaignsByNgo(ngoId)
      .subscribe((res: any) => {
        this.campaigns = res;
      });
  }

  public getNgo(): void {
    this.ngoService.getNgoById(this.ngoId).subscribe((result: any) => {
      this.ngoBody = new NgoModel(result);
      this.data = result;
      this.editedNgoBody = JSON.parse(JSON.stringify(this.ngoBody));
      this.socialMedia = new NgoSocialMediaModel(this.editedNgoBody?.socials);

      if (this.editedNgoBody.tags) {
        this.ngoTags = this.editedNgoBody.tags
          .split(',')
          .map((tag) => tag.trim());
      }
      if (this.editedNgoBody.ngo_sdg) {
        this.ngoSdg = this.editedNgoBody.ngo_sdg
          .split(',')
          .map((tag) => tag.trim());
      }
      if (this.editedNgoBody.cause_area) {
        const parsed = JSON.parse(this.editedNgoBody.cause_area);
        this.parsedCauseArea = Array.isArray(parsed) ? parsed : [];
        this.fetchParsedCauseArea();
      } else {
        this.parsedCauseArea = [];
        this.fetchParsedCauseArea();
      }
      if (this.editedNgoBody.work_area_geo_location) {
        const parsed = JSON.parse(this.editedNgoBody.work_area_geo_location);
        this.workingAddress = Array.isArray(parsed) ? parsed : [];
        this.loadWorkingAddresses(parsed);
      }
      this.ngoLogo = this.editedNgoBody?.logo_url
        ? JSON.parse(this.editedNgoBody?.logo_url)
        : {};

      this.ngoProfilePic = this.editedNgoBody?.ngo_profile_img_url
        ? JSON.parse(this.editedNgoBody?.ngo_profile_img_url)
        : {};

      this.getProgress(this.ngoBody);

      this.getAnnualReports();
      this.getNgoAward();
      this.getAllCampaignByNgo();
    });
  }

  public getProgress(result: any): void {
    this.totalKeys = 0;
    this.hasValue = 0;
    const socials = new NgoSocialMediaModel(result.socials);

    delete result['districts'];
    delete result['updated_at'];
    delete result['socials'];

    Object.entries(result).forEach(([key, value]) => {
      this.totalKeys += 1;
      if (value) {
        this.hasValue += 1;
      }
    });

    Object.entries(socials).forEach(([key, value]) => {
      this.totalKeys += 1;
      if (value) {
        this.hasValue += 1;
      }
    });

    this.progress = Math.floor((this.hasValue / this.totalKeys) * 100);
  }

  public onSave(
    no: number,
    fileName: string | null = null,
    imgProperty: string | null = null
  ): Observable<any> {
    const { isValid } = ValidationEngine.validateGroup('validationGrp');

    if (isValid) {
      this.deleteFile();

      return this.ngoService
        .updateNgoProfile(
          this.ngoId,
          this.editedNgoBody,
          this[`${fileName}File`],
          imgProperty
        )
        .pipe(
          tap((result: any) => {
            // Handle success logic
            this.sharedService.updateNgoProfile();
            this.ngoBody = JSON.parse(JSON.stringify(this.editedNgoBody));

            if (fileName) {
              this[`${fileName}File`] = null;
              this[fileName] = JSON.parse(this.ngoBody[imgProperty]);
            }

            this.utilitiesService.showSwalWithToast(
              'Success',
              'Updated Successfully!',
              'success'
            );
          }),
          catchError((err: any) => {
            this.utilitiesService.showSwalWithToast(
              err.error.error_name,
              err.error.message,
              'error'
            );
            return throwError(err);
          })
        );
    } else {
      // Return empty observable if validation fails
      return of(null);
    }
  }

  public onSaveMultiple(): void {
    const { isValid } = ValidationEngine.validateGroup('validationGrp');

    if (isValid) {
      forkJoin([
        this.onSave(4).pipe(catchError((err) => of(err))),
        this.onSave(1).pipe(catchError((err) => of(err))),
      ]).subscribe(([result4, result1]) => {
        // Handle combined results here
        this.editorOpened[15] = !this.editorOpened[15];
      });
    }
  }

  public onSaveSingle(
    no: number,
    fileName: string | null = null,
    imgProperty: string | null = null
  ): void {
    if (no === 6) {
      this.editedNgoBody.ngo_sdg = this.ngoSdg.join(',');
    }

    if (no === 7) {
      this.editedNgoBody.tags = this.ngoTags.join(',');
    }

    if (no === 8) {
      const preparedCauseArea = this.prepareCauseAreaForSave();
      this.editedNgoBody.cause_area = JSON.stringify(preparedCauseArea);
      this.parsedCauseArea = JSON.parse(this.editedNgoBody.cause_area);
    }

    if (no === 9) {
      const preparedWorkingAddress = this.prepareWorkingAddress();
      this.editedNgoBody.work_area_geo_location = JSON.stringify(
        preparedWorkingAddress
      );
    }

    if (no === 15) {
      this.editedNgoBody.socials = this.utilitiesService.jsonStringify(
        this.socialMedia
      );
      this.deleteFile();
      this.ngoService
        .updateNgoProfile(
          this.ngoId,
          this.editedNgoBody,
          this[`${fileName}File`],
          imgProperty
        )
        .subscribe({
          next: (result: any) => {
            this.sharedService.updateNgoProfile();

            this.ngoBody = JSON.parse(JSON.stringify(this.editedNgoBody));
            this.editorOpened[no] = !this.editorOpened[no];

            if (fileName) {
              this[`${fileName}File`] = null;
              this[fileName] = JSON.parse(this.ngoBody[imgProperty]);
            }

            this.utilitiesService.showSwalWithToast(
              'Success',
              'Updated Successfully!',
              'success'
            );
          },
          error: (err: any) => {
            this.utilitiesService.showSwalWithToast(
              err.error.error_name,
              err.error.message,
              'error'
            );
          },
        });
    } else {
      const { isValid } = ValidationEngine.validateGroup('validationGrp');
      if (isValid) {
        this.editedNgoBody.socials = this.utilitiesService.jsonStringify(
          this.socialMedia
        );
        this.deleteFile();

        this.ngoService
          .updateNgoProfile(
            this.ngoId,
            this.editedNgoBody,
            this[`${fileName}File`],
            imgProperty
          )
          .subscribe({
            next: (result: any) => {
              this.sharedService.updateNgoProfile();

              this.ngoBody = JSON.parse(JSON.stringify(this.editedNgoBody));
              this.editorOpened[no] = !this.editorOpened[no];

              if (fileName) {
                this[`${fileName}File`] = null;
                this[fileName] = JSON.parse(this.ngoBody[imgProperty]);
              }

              this.utilitiesService.showSwalWithToast(
                'Success',
                'Updated Successfully!',
                'success'
              );
            },
            error: (err: any) => {
              this.utilitiesService.showSwalWithToast(
                err.error.error_name,
                err.error.message,
                'error'
              );
            },
          });
      }
    }
  }

  private deleteFile(): void {
    if (this.imgToDelete.length > 0) {
      this.fileService
        .deleteFileMultiple(Array.from(new Set(this.imgToDelete)))
        .subscribe({
          next: (result: any) => {
            this.imgToDelete = [];
          },
          error: (err: any) => {
            this.utilitiesService.showSwalWithToast(
              'ERROR',
              'Image could not be removed'
            );
          },
        });
    }
  }

  public openEditor(
    no: number,
    bool: boolean = false,
    editPart?: string
  ): void {
    if (no === 15) {
      if (editPart === 'cover') {
        this.coverEdit = true;
        this.ngoProfileEdit = false;
        this.ngoInfoEdit = false;
      } else if (editPart === 'profile') {
        this.coverEdit = false;
        this.ngoProfileEdit = true;
        this.ngoInfoEdit = false;
      } else if (editPart === 'info') {
        this.coverEdit = false;
        this.ngoProfileEdit = false;
        this.ngoInfoEdit = true;
      }
    }
    // true if any editor is opened
    if (this.editorOpened.some(Boolean) && !bool) {
      Swal.fire({
        showCloseButton: true,
        showConfirmButton: false,
        icon: 'warning',
        title: 'Another editor opened!',
        html: 'Close the editor first.',
        allowOutsideClick: false,
      });
    } else {
      this.editedNgoBody = JSON.parse(JSON.stringify(this.ngoBody));
      this.editorOpened[no] = !this.editorOpened[no];

      this.ngoLogo = this.editedNgoBody?.logo_url
        ? JSON.parse(this.editedNgoBody?.logo_url)
        : {};
      this.ngoProfilePic = this.editedNgoBody?.ngo_profile_img_url
        ? JSON.parse(this.editedNgoBody?.ngo_profile_img_url)
        : {};

      this.ngoLogoFile = null;
      this.ngoProfilePicFile = null;
      this.annualReportModel = new annualReportModel();
      this.ngoAwardModel = new ngoAwardModel();

      // ✅ Reset the uploaded file
      this.ngoRegCertificate = null;

      const fileInput = document.getElementById(
        'ngoFileInput'
      ) as HTMLInputElement;

      if (fileInput) {
        fileInput.value = ''; // clears the file name
      }
    }
  }

  public onFileSelected(event: any, fileName: string): void {
    if (this[fileName]?.file_id) {
      this.imgToDelete.push(this[fileName].file_id);
    }
    this[`${fileName}File`] = event.target.files[0];
    this[fileName].url = URL.createObjectURL(event.target.files[0]);
  }

  public removeImage(fileName: string, imgProperty: string): void {
    if (this[fileName]?.file_id) {
      this.imgToDelete.push(this[fileName].file_id);
    }
    this[fileName] = {};
    this[`${fileName}File`] = null;
    this.editedNgoBody[imgProperty] = null;
  }

  public triggerFileInput(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  public processCauseAreaData() {
    this.categoryList = this.causeAreaList.filter((x) => x.parent_id === null);

    this.causeAreaList
      .filter((x) => x.parent_id !== null)
      .forEach((sub) => {
        if (!this.subCategoryMap[sub.parent_id]) {
          this.subCategoryMap[sub.parent_id] = [];
        }
        this.subCategoryMap[sub.parent_id].push(sub);
      });
  }

  public onCategoryChanged(event: any, index: number) {
    let selectedCategoryId = event.value;

    if (event.value && event.value.length > 1) {
      selectedCategoryId = [event.value[event.value.length - 1]];
      this.causeAreas[index].category = selectedCategoryId;
    }

    this.causeAreas[index].subcategories = [];
    this.causeAreas[index].availableSubcategories =
      this.subCategoryMap[selectedCategoryId] || [];

    this.updateAvailableCategories();
  }

  public addCategory() {
    if (this.causeAreas.length >= 10) {
      this.utilitiesService.showSwalWithToast(
        'Limit Reached',
        'You cannot add more than 10 cause areas.',
        'warning'
      );
      return;
    }
    const selectedCategories = this.causeAreas
      .map((c) => c.category)
      .flat()
      .filter(Boolean);

    this.causeAreas.push({
      category: null,
      subcategories: [],
      availableCategories: this.categoryList.filter(
        (cat) => !selectedCategories.includes(cat.id)
      ),
      availableSubcategories: [],
    });
  }

  public removeCategory(index: number) {
    this.causeAreas.splice(index, 1);
  }

  private fetchParsedCauseArea() {
    if (!Array.isArray(this.parsedCauseArea) || !this.parsedCauseArea.length) {
      this.causeAreas = [
        {
          category: [],
          subcategories: [],
          availableCategories: this.categoryList?.slice() || [],
          availableSubcategories: [],
        },
      ];
      return;
    }
    this.causeAreas = this.parsedCauseArea.map((item) => {
      const categoryObj = this.categoryList.find(
        (c) => c.title === item.category
      );
      const categoryId = categoryObj ? categoryObj.id : null;

      const subIds = (item.subcategories || [])
        .map((subTitle) => {
          const subObj = (this.subCategoryMap[categoryId] || []).find(
            (s) => s.title === subTitle
          );
          return subObj ? subObj.id : null;
        })
        .filter(Boolean);

      return {
        category: categoryId ? [categoryId] : [],
        subcategories: subIds,
        availableCategories: this.categoryList.filter(
          (c) => c.id !== categoryId
        ),
        availableSubcategories: this.subCategoryMap[categoryId] || [],
      };
    });
    this.updateAvailableCategories();
  }

  private updateAvailableCategories() {
    const selectedCategories = this.causeAreas
      .map((c) => c.category)
      .flat()
      .filter(Boolean);

    this.causeAreas.forEach((c) => {
      const filtered = this.categoryList.filter(
        (cat) =>
          !selectedCategories.includes(cat.id) || c.category.includes(cat.id)
      );

      c.availableCategories.length = 0;
      c.availableCategories.push(...filtered);
    });
  }

  private prepareCauseAreaForSave(): {
    category: string;
    subcategories: string[];
  }[] {
    return this.causeAreas.map((item) => {
      const catTitle =
        this.categoryList.find((c) => c.id == item.category)?.title || '';

      const subTitles = (item.subcategories || [])
        .map((subId: number) => {
          return (
            item.availableSubcategories.find((s) => s.id == subId)?.title || ''
          );
        })
        .filter((title) => title);

      return {
        category: catTitle,
        subcategories: subTitles,
      };
    });
  }

  // Validation: Allowed characters
  public validateAllowedCharacters = (options) => {
    const value = options.value || [];
    const pattern = /^[A-Za-z0-9\s\-\&’]+$/;
    return value.every((tag) => pattern.test(tag));
  };

  // Validation: Maximum tag length 30
  public validateMaxTagLength = (options) => {
    const value = options.value || [];
    return value.every((tag) => tag.length <= 30);
  };

  // Validation: Maximum 10 tags
  public validateMaxNumberTags = (options) => {
    const value = options.value || [];
    return value.length <= 10;
  };

  // Validation: Duplicates within same NGO
  public validateDuplicates = (options) => {
    const value = options.value || [];
    const lower = value.map((t) => t.toLowerCase());
    return new Set(lower).size === lower.length;
  };

  private buildLocationsTree(data: any[]) {
    const divisionsMap = new Map();
    data.forEach((item) => {
      if (!divisionsMap.has(item.division_id)) {
        divisionsMap.set(item.division_id, {
          divisionId: item.division_id,
          divisionName: item.division_name,
          districts: [],
        });
      }
      const division = divisionsMap.get(item.division_id);
      let district = division.districts.find(
        (d) => d.districtId === item.district_id
      );
      if (!district) {
        district = {
          districtId: item.district_id,
          districtName: item.district_name,
          upazilas: [],
        };
        division.districts.push(district);
      }
      if (!district.upazilas.find((u) => u.upazilaId === item.upazila_id)) {
        district.upazilas.push({
          upazilaId: item.upazila_id,
          upazilaName: item.upazila_name,
        });
      }
    });
    return Array.from(divisionsMap.values());
  }

  public onDivisionChanged(event: any, index: number) {
    let selectedDivisionId = event.value;

    if (event.value && event.value.length > 1) {
      selectedDivisionId = [event.value[event.value.length - 1]];
      this.workingAddress[index].division = selectedDivisionId;
    }

    const division = this.locationsTree.find(
      (d) =>
        d.divisionId ===
        (Array.isArray(selectedDivisionId)
          ? selectedDivisionId[0]
          : selectedDivisionId)
    );

    this.workingAddress[index].availableDistricts = division?.districts || [];
    this.workingAddress[index].district = null;
    this.workingAddress[index].upazila = null;
    this.workingAddress[index].union = null;
    this.workingAddress[index].availableUpazilas = [];
    this.workingAddress[index].availableUnions = [];
  }

  public onDistrictChanged(event: any, index: number) {
    let selectedDistrictId = event.value;

    if (event.value && event.value.length > 1) {
      selectedDistrictId = [event.value[event.value.length - 1]];
      this.workingAddress[index].district = selectedDistrictId;
    }

    const selectedDivision = this.workingAddress[index].division;
    const selectedDivisionId = Array.isArray(selectedDivision)
      ? selectedDivision[selectedDivision.length - 1]
      : selectedDivision;

    const division = this.locationsTree.find(
      (d) => d.divisionId === selectedDivisionId
    );

    const district = division.districts.find(
      (d) =>
        d.districtId ===
        (Array.isArray(selectedDistrictId)
          ? selectedDistrictId[0]
          : selectedDistrictId)
    );

    this.workingAddress[index].availableUpazilas = district?.upazilas || [];
    this.workingAddress[index].upazila = null;
    this.workingAddress[index].union = null;
    this.workingAddress[index].availableUnions = [];
  }

  public onUpazilaChanged(event: any, index: number) {
    let selectedUpazilaId = event.value;

    if (event.value && event.value.length > 1) {
      selectedUpazilaId = [event.value[event.value.length - 1]];
      this.workingAddress[index].upazila = selectedUpazilaId;
    }

    const upazilaId = Array.isArray(selectedUpazilaId)
      ? selectedUpazilaId[0]
      : selectedUpazilaId;

    this.workingAddress[index].availableUnions = [];
    this.workingAddress[index].union = null;

    this.getUnionsByUpazilaId(upazilaId).subscribe((res) => {
      this.workingAddress[index].availableUnions = res || [];
    });
  }

  public onUnionChanged(event: any, index: number) {
    let selectedUnionId = event.value;

    if (event.value && event.value.length > 1) {
      selectedUnionId = [event.value[event.value.length - 1]];
      this.workingAddress[index].union = selectedUnionId;
    }
  }

  public addAddress() {
    this.workingAddress.push({
      division: null,
      district: null,
      upazila: null,
      union: null,
      ward: null,
      availableDistricts: [],
      availableUpazilas: [],
      availableUnions: [],
    });
  }

  public removeAddress(index: number) {
    this.workingAddress.splice(index, 1);
  }

  private getId(value: any, key: string): string | null {
    if (!value) return null;

    if (Array.isArray(value)) {
      return this.getId(value[0], key);
    }

    if (typeof value === 'object' && value[key]) {
      return value[key];
    }

    return value;
  }

  private prepareWorkingAddress(): any[] {
    return this.workingAddress.map((addr) => {
      const divisionId = this.getId(addr.division, 'divisionId');
      const districtId = this.getId(addr.district, 'districtId');
      const upazilaId = this.getId(addr.upazila, 'upazilaId');
      const unionId = this.getId(addr.union, 'union_id');

      const divisionObj = this.locationsTree.find(
        (d) => d.divisionId === divisionId
      );
      const districtObj = divisionObj?.districts.find(
        (d) => d.districtId === districtId
      );
      const upazilaObj = districtObj?.upazilas.find(
        (u) => u.upazilaId === upazilaId
      );
      const unions = this.unionMap[String(upazilaId)] || [];
      const unionObj = unions.find(
        (u) => String(u.union_id) === String(unionId)
      );

      return {
        division: {
          divisionId,
          divisionName: divisionObj?.divisionName || '',
        },
        district: {
          districtId,
          districtName: districtObj?.districtName || '',
        },
        upazila: {
          upazilaId,
          upazilaName: upazilaObj?.upazilaName || '',
        },
        union: {
          union_id: unionId || null,
          union_name: unionObj?.union_name || addr.union?.union_name || '',
        },
        ward: addr.ward || '',
      };
    });
  }

  private loadWorkingAddresses(data: any[]) {
    data.forEach((addr, i) => {
      this.workingAddress[i] = this.workingAddress[i] || {
        division: null,
        district: null,
        upazila: null,
        union: null,
        ward: null,
        availableDistricts: [],
        availableUpazilas: [],
        availableUnions: [],
      };

      const divisionId = addr.division?.divisionId || addr.division;
      const districtId = addr.district?.districtId || addr.district;
      const upazilaId = addr.upazila?.upazilaId || addr.upazila;
      const unionId = addr.union?.union_id || addr.union;

      const division = this.locationsTree.find(
        (d) => d.divisionId === divisionId
      );
      this.workingAddress[i].availableDistricts = division?.districts || [];
      this.workingAddress[i].division = divisionId ? [divisionId] : null;

      const district = division?.districts.find(
        (d) => d.districtId === districtId
      );
      this.workingAddress[i].availableUpazilas = district?.upazilas || [];
      this.workingAddress[i].district = districtId ? [districtId] : null;

      const upazila = district?.upazilas.find((u) => u.upazilaId === upazilaId);
      this.workingAddress[i].upazila = upazilaId ? [upazilaId] : null;

      this.getUnionsByUpazilaId(upazilaId).subscribe((res) => {
        this.workingAddress[i].availableUnions = res || [];

        if (unionId) {
          const unionObj = res.find(
            (u: any) => String(u.union_id) === String(unionId)
          );
          this.workingAddress[i].union = unionObj
            ? [unionObj.union_id]
            : [unionId];
        } else {
          this.workingAddress[i].union = null;
        }
      });

      this.workingAddress[i].ward = addr.ward || '';
    });
  }

  private getUnionsByUpazilaId(upazilaId: string): Observable<any[]> {
    if (this.unionMap[upazilaId]) {
      return of(this.unionMap[upazilaId]);
    }

    return this.ngoService.getUnionByUpazilaId(upazilaId).pipe(
      tap((res) => {
        this.unionMap[upazilaId] = res || [];
      })
    );
  }

  public getLocationName(
    id: string | string[],
    type: 'division' | 'district' | 'upazila' | 'union'
  ): string {
    if (!id) return '';
    const actualId = Array.isArray(id) ? id[0] : id;

    switch (type) {
      case 'division': {
        const division = this.locationsTree.find(
          (d) => d.divisionId === actualId
        );
        return division?.divisionName || '';
      }
      case 'district': {
        for (const div of this.locationsTree) {
          const dist = div.districts.find((d) => d.districtId === actualId);
          if (dist) return dist.districtName;
        }
        return '';
      }
      case 'upazila': {
        for (const div of this.locationsTree) {
          for (const dist of div.districts) {
            const upa = dist.upazilas.find((u) => u.upazilaId === actualId);
            if (upa) return upa.upazilaName;
          }
        }
        return '';
      }
      case 'union': {
        const id = Array.isArray(actualId) ? actualId[0] : actualId;
        for (const upaId in this.unionMap) {
          const unions = this.unionMap[upaId];
          const found = unions.find((u) => u.union_id === id);
          if (found) return found.union_name;
        }
        return '';
      }

      default:
        return '';
    }
  }

  public hasValidAddress(): boolean {
    return this.workingAddress.some(
      (addr) =>
        addr.division ||
        addr.district ||
        addr.upazila ||
        addr.union ||
        addr.ward
    );
  }

  public truncate(text: string, maxLength: number): string {
    if (!text) return '';
    return text.length > maxLength
      ? text.substring(0, maxLength) + '...'
      : text;
  }

  public toggleExpand(index: number) {
    this.expandedState[index] = !this.expandedState[index];
  }

  public getAnnualReports(): void {
    this.ngoService.getAnnualReports(this.ngoId).subscribe((result: any) => {
      this.allAnnualReports = result.map((report) => ({
        ...report,
        report_url: report.report_url ? JSON.parse(report.report_url) : null,
      }));

      // Initially show only 4 reports
      this.annualReports = this.allAnnualReports.slice(0, 4);
    });
  }

  public getNgoAward(): void {
    this.ngoService.getAwardList(this.ngoId).subscribe((result: any) => {
      this.allAwardData = result;

      // Initially show only 4 awards
      this.awardData = this.allAwardData.slice(0, 4);
    });
  }

  public toggleShowAll(): void {
    this.showAll = !this.showAll;
    if (this.showAll) {
      // Show all reports
      this.annualReports = this.allAnnualReports;
    } else {
      // Show only first 4 again
      this.annualReports = this.allAnnualReports.slice(0, 4);
    }
  }

  public updateVisibleAwards() {
    this.showAll2 = !this.showAll2;
  }

  public onPdfFileSelected(e: any, fileName: string): void {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this[fileName] = input.files[0];
    }
  }

  //drag-and-drop-files
  private isValidFileType(file: File): boolean {
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    return allowedTypes.includes(file.type);
  }

  public onDropSuccess(event: DragEvent, fileName: string) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.isValidFileType(file)) {
          this.handleFile(file, fileName);
        } else {
          alert('Invalid file type. Please upload a PDF file.');
        }
      }
    }
  }
  private handleFile(file: File, fileName: string) {
    this[fileName] = file;
  }

  public onDragOver(event: DragEvent) {
    event.preventDefault();
    const items = event.dataTransfer?.items;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file && !this.isValidFileType(file)) {
            event.dataTransfer.dropEffect = 'none';
            return;
          }
        }
      }
      event.dataTransfer.dropEffect = 'copy';
    }
  }

  public removeFile(fileName: string): void {
    this[fileName] = null;
  }

  public submit(no: number): void {
    if (no === 14) {
      const { isValid } = ValidationEngine.validateGroup('reportValidationGrp');

      if (isValid) {
        this.uploadFile(this.ngoRegCertificate, 'report_url').subscribe(
          (res) => {
            this.annualReportModel.ngo_id = this.ngoId;
            this.ngoService
              .createAnnualReport(this.annualReportModel)
              .subscribe((result) => {
                this.getAnnualReports();
                this.annualReportModel = new annualReportModel();
                this.editorOpened[no] = !this.editorOpened[no];
              });
          }
        );
      }
    } else if (no === 13) {
      const { isValid } = ValidationEngine.validateGroup('awardValidationGrp');

      if (isValid) {
        this.ngoAwardModel.ngo_id = this.ngoId;
        this.ngoService.createAward(this.ngoAwardModel).subscribe((result) => {
          this.getNgoAward();
          this.ngoAwardModel = new ngoAwardModel();
          this.editorOpened[no] = !this.editorOpened[no];
        });
      }
    }
  }

  private uploadFile(file: File | null, key: string) {
    if (!file) {
      return of(null);
    }
    return this.fileService.uploadSingleFile(file).pipe(
      map((response) => {
        this.annualReportModel[key] = JSON.stringify(response[0]);
      })
    );
  }
}
